import { CustomPatientGroupsForm } from '../shared/form/CustomPatientGroupsForm';

export const CustomPatientGroupsUpdateForm = CustomPatientGroupsForm;
